// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const container = document.querySelector(".iitjee-math-container");
    if (container) {
      container.scrollTop = 0; // scroll the container
    } else {
      window.scrollTo(0, 0); // fallback for page scroll
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;

